import gql from "@apollo/client";

const MUTATE_TARGET_ACTION = gql`
	mutation ($uuid: String, $lead_form_type: String, $position: Int, $ab_tests_json: String) {
		targetAction(
			uuid: $uuid
			lead_form_type: $lead_form_type
			position: $position
			ab_test: $ab_tests_json
		)
	}
`;

export default MUTATE_TARGET_ACTION;
